import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { LookupService } from '@admin/shared/services/lookup.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';

@Injectable()
export class PortfolioLookupResolveService {
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    //TODO: load only reuqired lookups and configs
    return this.configurationService.loadAllConfigs();
  }

  constructor(
    private lookupService: LookupService,
    private configurationService: ConfigurationService
  ) {}
}
